import { Plan } from './components/Plan';
import withTableController from '../../../../../HOC/tableController/withTableControllerForAdminPlanning';

const Plan21 = withTableController(({ planing, state }) => (
  <Plan planing={planing} state={state} />
));

export default Plan21;
